// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_Yv_","cls2":"RelatedPapers-cls2_Izg RelatedPapers-cls1_Yv_"};